module.exports = __webpack_public_path__ + "img/display cctv.ea545abd.jpg";